import types from './types';

const initialState = {
  menuToEdit: {},
  menuEditRequest: false,
  menuEditSuccessful: false,
  menuEditError: ''
};

export const editMenuReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_MENU_TO_EDIT: {
      const { menu } = action;
      const { meals } = menu;

      /**
       * need to format the meals for the data table in an array of objects with `food` and `mealtime` properties
       * then flatten the array of arrays into one
       */
      const arrayOfArrays = meals.map(meal => {
        const { foods, mealtime } = meal;
        return foods.map(food => ({ food, mealtime }));
      });
      const flatten = [].concat.apply([], arrayOfArrays);

      return {
        ...state,
        menuToEdit: {
          ...action.menu,
          formattedMealsArray: flatten
        }
      };
    }
    case types.RESET_MENU_TO_EDIT: {
      return {
        menuToEdit: {},
        menuEditRequest: false,
        menuEditSuccessful: false,
        menuEditError: ''
      };
    }
    case types.EDIT_MENU_REQUEST: {
      return {
        ...state,
        menuEditRequest: true,
        menuEditSuccessful: false,
        menuEditError: ''
      };
    }
    case types.EDIT_MENU_SUCCESS: {
      return {
        ...state,
        menuEditRequest: false,
        menuEditSuccessful: true,
        menuEditError: ''
      };
    }
    case types.EDIT_MENU_FAILURE: {
      return {
        ...state,
        menuEditRequest: false,
        menuEditSuccessful: false,
        menuEditError: action.error
      };
    }
    default:
      return state;
  }
};
